<ng-container *ngIf="!(activeReferencesService.createListLoading$ | async) && !fetchReferencesLoading, else loadingTemplate">

  <div class="references-box" *ngIf="(items && items.length), else noReferencesTemplate">
    <div
      class="references-box_icon"
      (click)="onClose()">
      <fa-icon [icon]="['fal', 'times']"></fa-icon>
    </div>
    <div class="references-box_title">Active References List</div>
    <div class="references-box_content">
      The temporary list below shows the references cited in this document.
    </div>
    <div class="references-box_link-container">
      Copy List:&nbsp;
      <span 
        (click)="onCopyBibTex()" 
        class="pointer" 
        title="Copy to Clipboard">
        <span class="references-box_link">BibTeX</span>
        <fa-icon [icon]="['fal', 'copy']"></fa-icon>
      </span>
      &nbsp;&nbsp;
      <span 
        (click)="onCopyRis()" 
        class="pointer" 
        title="Copy to Clipboard">
        <span class="references-box_link">RIS</span>
        <fa-icon [icon]="['fal', 'copy']"></fa-icon>
      </span>
    </div>
    <form 
      class="references-box_form relative"
      [formGroup]="form">
      <input 
        class="references-box_input form-control"
        formControlName="listName"
        type="text"
        placeholder="Enter list name...">
      <scs-field-error [control]="form.controls.listName" class="form-error"></scs-field-error>

      <div #collectionBox>
        <button
          class="button-primary references-box_button"
          [disabled]="!form.valid"
          (click)="openCollectionPopup()">
          Save To
        </button>
        <div
          class="scs-dropdown scs-dropdown--right scrollbar"
          [ngClass]="{ 'hidden': !isCollectionDropdownVisible}">
          <navigation-collection
            [collection]="personalCollection"
            [listExplorerMode]="true"
            (onCreateList)="createList($event)">
          </navigation-collection>
          <navigation-collection-shared
            *ngFor="let collection of sharedCollections"
            [collection]="collection"
            [listExplorerMode]="true"
            [canManage]="collection.user?.can_manage_list && collection.user?.can_manage_item"
            (onCreateList)="createList($event)">
          </navigation-collection-shared>
        </div>
      </div>
    </form>

  </div>

  <div  class="scroll-wrapper scroll-wrapper--xxs scrollbar block" [ngClass]="{'padding-bottom-xxl': isCitationDrawerVisible}">
    <div *ngFor="let item of items" class="list-item">
      <div
      class="list-item_checkbox"
      [ngClass]="{'list-item_checkbox--checked': item.isChecked}"
      (click)="onItemChecked(item, $event)">
    </div>
      <div 
        class="list-item_title"
        (click)="itemsDisplayService.showItemPanel(item)"
        [innerHTML]="item.article?.title || 'Untitled'">
      </div>
      <div class="list-item_author-box">
        <ng-container *ngIf="!!item.article?.displayedAuthors.length">
          <div 
            *ngFor="let author of (item.article?.isFullAuthorsShown ? item.article?.authors : item.article?.displayedAuthors)"
            class="list-item_author">
            {{ item.import_data?.source === 'janssen_endnote' ? author : (author | formatAuthor) }}
          </div>
        </ng-container>
        <span 
          *ngIf="!!item.article?.nonDisplayedAuthorsCount"
          (click)="toggleShowAuthors(item)"
          class="badge">
          {{ item.article.isFullAuthorsShown ? 'less' : ('+ ' + item.article.nonDisplayedAuthorsCount + (item.article.nonDisplayedAuthorsCount === 1 ? ' author' : ' authors')) }}
       </span>
      </div>
      <div class="list-item_journal-box">
        {{ item.article?.journal ? (item.article.journal + ' ') : ''}}{{(item.article?.journal && item.article?.year) ? ' | ' : '' }}{{ item.article?.year ? item.article.year : '' }}
      </div>
    </div>
  </div>

  <scs-citation-drawer *ngIf="isCitationDrawerVisible"></scs-citation-drawer>

</ng-container>

<ng-template #loadingTemplate>
  <div class="loader_overlay">
    <scs-loader class="center-horizontal-vertical"></scs-loader>
  </div>
</ng-template>

<ng-template #noReferencesTemplate>
  <div class="text--center text--sm padding-top-md">
    <i>Currently there are no citations in the document.</i>
  </div>
  <div
    class="references-box_icon"
    (click)="onClose()">
    <fa-icon [icon]="['fal', 'times']"></fa-icon>
  </div>
</ng-template>
